import type { IconSvgObject } from './types';

const TransitionTopIcon: IconSvgObject = [
  ["path", { d: "M2.99994 20C2.99994 20.5523 3.44765 21 3.99994 21L19.9999 21C20.5522 21 20.9999 20.5523 20.9999 20V15C20.9999 14.4477 20.5522 14 19.9999 14L3.99994 14C3.44765 14 2.99994 14.4477 2.99994 15L2.99994 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M2.99994 7L2.99994 4C2.99994 3.44772 3.44765 3 3.99994 3L19.9999 3C20.5522 3 20.9999 3.44772 20.9999 4V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M11.9999 6L14.9999 9M11.9999 6L8.99994 9M11.9999 6L11.9999 14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default TransitionTopIcon;
